import { __module as u } from "./ghl-ui.es1682.js";
(function(i, l) {
  Object.defineProperty(l, "__esModule", {
    value: !0
  }), l.default = n;
  function n(t) {
    return function(d, e) {
      var f = e != null && e.context ? String(e.context) : "standalone", a;
      if (f === "formatting" && t.formattingValues) {
        var r = t.defaultFormattingWidth || t.defaultWidth, v = e != null && e.width ? String(e.width) : r;
        a = t.formattingValues[v] || t.formattingValues[r];
      } else {
        var c = t.defaultWidth, m = e != null && e.width ? String(e.width) : t.defaultWidth;
        a = t.values[m] || t.values[c];
      }
      var b = t.argumentCallback ? t.argumentCallback(d) : d;
      return a[b];
    };
  }
  i.exports = l.default;
})(u, u.exports);
var x = u.exports;
export {
  x as b
};
